<template>
    <form @submit.prevent="editState">
        <div>
            <label class="block mb-1" for="name">{{ $t('labels.name') }}</label>
            <InputText
                v-model="state.name"
                name="name"
                type="text"
                placeholder="name in Japanese"
                class="w-full"
                />      
                <p v-if="errors.name" class="text-sm text-danger">{{ errors.name[0] }}</p>          
        </div>
        <div class="mt-3">
            <label class="block mb-1" for="name">{{ $t('labels.name_en') }}</label>
            <InputText
                v-model="state.name_en"
                name="name_en"
                type="text"
                placeholder="name in English"
                class="w-full"
                />      
                <p v-if="errors.name_en" class="text-sm text-danger">{{ errors.name_en[0] }}</p>          
        </div>
        <div class="flex justify-end mt-6">
            <button :disabled="loading" class="px-6 py-2 text-white rounded outline-none bg-secondary ring-0">
                <span v-if="loading">Loading</span>
                <span v-else>{{ $t('actions.update') }}</span>
            </button>
        </div>
    </form>
</template>

<script setup>
import { ref , defineEmits , defineProps, onMounted } from 'vue';
import ApiService from '@/services/ApiService';
import { toast } from 'vue3-toastify';

//prime vue components
import InputText from 'primevue/inputtext';

const props = defineProps({
    id : Number
})
const emit = defineEmits(['edited']);

const state = ref({
    name : '',
    name_en : ''
})
const errors = ref({});
const loading = ref(false);

const editState = () => {
    loading.value = true;
    const id = toast.loading('Updating, please wait . . .');
    ApiService.put(`states/${props.id}` , state.value).then(() => {
        loading.value = false;
        toast.update(id, {
            render: "Updated state.",
            autoClose: true,
            closeOnClick: true,
            closeButton: true,
            type: 'success',
            isLoading: false,
        });
        emit('edited');
    }).catch((res) => {
        loading.value = false;
        toast.update(id, {
            render: "Error updating state.",
            autoClose: true,
            closeOnClick: true,
            closeButton: true,
            type: 'error',
            isLoading: false,
        });
        errors.value = res?.response?.data && res?.response?.data?.errors ? res?.response?.data?.errors : {};
    })
}

onMounted(() => {
    ApiService.get(`states/${props.id}`).then((res) => {
        state.value = res.data
    }).catch(() => {
        toast.error("Error fetching data.");
    })
})
</script>

<style scoped>

</style>